module.exports = __webpack_public_path__ + "img/collection-engagementRingsHalo.27f4028.webp";